import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ChangePasswordModal.module.css';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const handleEditProfile = () => {
    navigate('/edit-profile');
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 12 }}>
          <WarningAmberRoundedIcon style={{ color: '#f59e42', fontSize: 48, marginBottom: 8 }} />
          <h2 style={{ fontSize: 24, fontWeight: 700, margin: 0, color: '#222', textAlign: 'center' }}>Change Your Password</h2>
        </div>
        <p style={{ fontSize: 17, color: '#555', margin: '0 0 24px 0', textAlign: 'center' }}>
          For your security, you must change your password upon first login.<br />
          Click the button below to update your password now.
        </p>
        <div className={styles.buttonContainer} style={{ gap: 0, flexDirection: 'column' }}>
          <button
            className={styles.changePasswordButton}
            style={{ width: '100%', marginBottom: 12, fontWeight: 600, fontSize: 17 }}
            onClick={handleEditProfile}
          >
            Change Password
          </button>
          <button
            className={styles.cancelButton}
            style={{ width: '100%', fontWeight: 500, fontSize: 16 }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;